import template from "js/templates/steps/shift-preference.jst";
import { heapTrack } from "lib/analytics";

import { BaseStep } from "./base";

const ShiftPreferenceStep = BaseStep.extend({
    name: "STEP_SHIFT_PREFERENCE",
    template,

    ui: {
        select: "select",
    },

    events: {
        "change @ui.select": "onCheckComplete",
    },

    getPositions() {
        if (!this.multipleShiftPositions) {
            this.multipleShiftPositions = this.positions.filter((p) => {
                const shifts = (p.get("schedule_start") || "").split(" or ");
                const pref = p.get("pref_shift_start");
                return (
                    !p.get("disable_preferred_shift") &&
                    !window.activePids.includes(p.id) &&
                    // Only if we need to select a shift
                    shifts.length > 1 &&
                    // Always show all options on review page
                    (this.options.isReview ||
                        // Otherwise only if they haven't selected something
                        (pref !== "Any" && !shifts.includes(pref)))
                );
            });
        }

        return this.multipleShiftPositions;
    },

    shouldSkip() {
        // Skip if they've already filled out prefs or the
        // position doesn't have multiple start times
        return this.getPositions().length === 0;
    },

    postInit() {
        this.showNextButton = false;
    },

    postRender() {
        this.getNextButton().fadeOut();

        heapTrack("Shift Preference - Shown", {
            count: this.getPositions().length,
        });
    },

    serializeData() {
        return {
            positions: this.getPositions().map((p) => ({
                ...p.attributes,
                shifts: p.get("schedule_start").split(" or "),
            })),
        };
    },

    onCheckComplete() {
        const completed = this.ui.select
            .toArray()
            .map((s) => s.value)
            .filter(Boolean);
        if (completed.length === this.ui.select.length) {
            this.getNextButton().fadeIn();
        } else {
            this.getNextButton().fadeOut();
        }
    },

    getData() {
        const prefs = {};
        this.ui.select.each((idx, el) => {
            prefs[el.name] = el.value;
        });

        return { pref_shift_start: prefs };
    },
});

export default ShiftPreferenceStep;
